import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Contact from './pages/Utils/Contact';
import AideDeJeu from './pages/Principal/AideDeJeu';
import Bonus from './pages/Principal/Bonus';
import Univers from './pages/Principal/Univers';
import Validation from './pages/Principal/Validation';
import Fin from './pages/Second/Fin';
import Fin2 from './pages/Second/Fin2';
import MentionsLegales from './pages/Utils/MentionsLegales';
import LeSceau from './pages/Second/LeSceau';

import Sablier from './pages/Second/Sablier';
import Kodama from './pages/Second/Kodama';
import CodeBonus from './pages/Second/0230';

import EnigmesTome2 from './pages/Utils/ETome2';
import enigmesConfig from './components/enigmes/enigmesConfig';

import Sceau from './pages/Second/Sceau';

import NotFound from './pages/404';
import NormalizeRoute from './components/NormalizeRoute';

import BackgroundWrapper from './components/BackgroundWrapper';
import './css/App.css';
import useScrollToTop from './components/useScrollToTop';
import MusiqueRedirect from './pages/Utils/MusiqueRedirect';





function App() {

  return (
    <Router>
      <ScrollToTop />
      <BackgroundWrapper>
        <Navbar />
        <div className="container">
          <NormalizeRoute>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/musique/:musiqueId" element={<MusiqueRedirect />} />
            <Route path="/aidedejeu" element={<AideDeJeu />} />
            <Route path="/bonus" element={<Bonus />} />
            {/* adresses d'entrée des énigmes Passe-Temps de l'ancien site (liens d'astolie.fr) */}
            <Route path="/la-gardienne-du-temps" element={<Bonus enigme="la-gardienne-du-temps" />} />
            <Route path="/solstice-des-glaces" element={<Bonus enigme="solstice-des-glaces" />} />
            <Route path="/univers" element={<Univers />} />
            <Route path="/validation" element={<Validation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fin" element={<Fin />} />
            <Route path="/mentionslegales" element={<MentionsLegales />} />
            <Route path="/le-sceau" element={<LeSceau />} />
            <Route path="/sceau" element={<Sceau />} />

            <Route path="/sablier" element={<Sablier />} />
            <Route path="/kodama" element={<Kodama />} />
            <Route path="/0230" element={<CodeBonus />} />


            <Route path="/fin2" element={<Fin2 />} />

            {Object.entries(enigmesConfig).map(([lieu, config]) => (
              <Route
                key={lieu}
                path={`/${lieu}`}
                element={<EnigmesTome2
                  key={lieu}
                  titre={lieu}
                  enigmesData={config.enigmesData}
                  imageSrc={config.imageSrc}
                />}
              />
            ))}

            <Route path="*" element={<NotFound />} />
          </Routes>
          </NormalizeRoute>
        </div>
      </BackgroundWrapper>
      <Footer />
    </Router>
  );
}


const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

export default App;
